<template>
    <svg role="img" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 13.25 13.25" fill="none" aria-label="Details view icon">
        <rect x="0.625" y="0.625" width="12" height="12" rx="1" stroke="currentColor" stroke-width="1.25" />
        <line x1="3.628" y1="4.2" x2="9.578" y2="4.2" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" />
        <line x1="3.629" y1="6.7" x2="9.579" y2="6.7" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" />
        <circle cx="3.7" cy="9.325" r="0.7" fill="currentColor" />
        <circle cx="6.125" cy="9.325" r="0.7" fill="currentColor" />
        <circle cx="8.625" cy="9.325" r="0.7" fill="currentColor" />
    </svg>
</template>
